import React, { useRef, useEffect, useState } from "react";
import SubCategoryItem from "./SubCategoryItem";
import "./styles.scss";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import SupportingMaterialService from "../../services/SupportingMaterialService";

type Props = {
  cat:any;
  // children: React.ReactNode;  
  isOpen: boolean;
  isHighlight: boolean;
  onClick: () => void;
};

export default function CategoryItem({
  cat,
  // children?,
  isOpen,
  isHighlight,
  onClick
}: Props) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const [subCategory, setSubCategory] = useState<any>(null);
  const [openIndexSub, setOpenIndexSub] = useState<number | null>(null);
  const [isLoad, setIsLoad] = useState<Boolean>(false);
  const handleToggleSub = (indexSub: number) => {
      setOpenIndexSub(openIndexSub === indexSub ? null : indexSub);
  };
  const getCategory = async (id:number) => {
         if(id<= 0) return;
         setIsLoad(true);
         SupportingMaterialService.getCategorySubAndItemsById(id)
            .then((response: any) => {
                if (response) { setSubCategory(response.subCategories); }
                setIsLoad(false);
            }).catch((error: any) => {setIsLoad(false); });
    }

    useEffect(() => {
        getCategory(Number(cat.id??"0"));
    }, []);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setMaxHeight(contentRef.current.scrollHeight);
    } else {
      setMaxHeight(0);
    }
  }, [isOpen]);

  return (
    <div style={{ marginBottom: 10 }}>
      {
          isLoad === true &&
          <LoadingSpinner />
      }
      {
        (cat.isSeparator !== true) ?
        <>
        <div
          onClick={onClick}
          className={`boxCategory ${isHighlight ? "boxCategoryHighlight" : ""}`}
          style={{backgroundColor: isOpen ? "#ffffff" : "#1B8E3E"}}
        >
          {!isOpen && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <i
                className={`mdi ${isHighlight ? "mdi-play-circle iconHighlightColor" : "mdi-chevron-right"}`}
                style={{ fontSize: 20, color: "#281f74" }}
              />
            </div>
          )}

          <div className={`boxTitleOpen ${isOpen ? "" : "boxTitleOpenCategory"}`} style={{textAlign: isOpen ? "left" : "center",color: isOpen ? "#1B8E3E" : "#fff"}}>
            {cat.title}
            {
              cat.subTitle &&
                <span className="subtitleInTile" style={{display: isOpen ? "block" : "none"}} >{cat.subTitle}</span>
            }
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifySelf: "end",
              marginTop: isOpen ? 6 : 0
            }}
          >
            <div
              style={{
                width: 21,
                height: 21,
                borderRadius: "50%",
                border: "1px solid",
                borderColor: isOpen ? "transparent" : "#fff",
                color: "#fff",
                backgroundColor: isOpen ? "#1B8E3E" : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <i
                className="mdi mdi-chevron-double-down"
                style={{
                  transition: "0.3s",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  fontSize: 18
                }}
              />
            </div>

            <span
              style={{
                color: "#a9a9ac",
                fontSize: 9,
                marginTop: 2,
                display: isOpen ? "block" : "none"
              }}
            >
              Fechar
            </span>
          </div>
          {
            isOpen && (
            <div
              style={{
                gridColumn: "1 / -1", 
                width: "90%",
                height: 1,
                backgroundColor: "rgb(204 204 204 / 42%)",
                margin: "2px auto 0 auto"
              }}
            />
            )
          }
          
        </div>
        <div
          style={{
            overflow: "hidden",
            maxHeight: isOpen ? 2000 : 0,
            transition: "height 0.3s ease"
          }}
        >
          <div ref={contentRef} className="boxContent" >
            {subCategory?.sort((a:any, b:any) => a.ordem - b.ordem)?.map((subcat:any, index:number) => (
                <SubCategoryItem
                    key={index}
                    subCategories={subcat}
                    isOpenSub={openIndexSub === index}
                    onClickSub={() => handleToggleSub(index)}
                />
            ))}
          </div>
        </div>
        </> :
        <>
          <div style={{background: "#ffffff", padding:10, display: "flex", alignItems: "center"}}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 6, paddingBottom: 3, width: '100%', fontWeight: 'bold', borderBottom: '1px solid #e0e0e0', color:'#248741' }}>
              <i className="mdi mdi-arrow-down-drop-circle" style={{ color: '#97f80c', fontSize: 20 }} />
              {cat.title}
            </span>
          </div>
        </>
      }

    </div>
  );
}